import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const Header = {
	init() {
		const header = document.querySelector('header');
		setTimeout(() => {
			document.body.classList.add('ready');
		}, 100);

		ScrollTrigger.create({
			start: 'top top',
			end: 99999,
			onUpdate: (self) => {
				if (self.direction === -1) {
					document.body.classList.remove('hide-headers');
				} else {
					document.body.classList.add('hide-headers');
				}
			},
		});

		ScrollTrigger.create({
			start: '10px top',
			end: 99999,
			onToggle: (self) => document.body.classList.toggle('scrolling'),
		});

		let scrollto = document.querySelectorAll('#property-nav a');
		scrollto.forEach((scroll) => {
			scroll.addEventListener('click', function (e) {
				// scroll one page down
				if (/#/.test(scroll.href)) {
					console.log(scroll.href);
					e.preventDefault();
					const _section = document.querySelector(
						'#' + scroll.href.split('#')[1]
					);
					if (_section) {
						window.scrollTo({
							top: _section.offsetTop,
							behavior: 'smooth',
						});
					} else {
						const _section2 = document.querySelector(
							'.wp-block-group.' + scroll.href.split('#')[1]
						);
						window.scrollTo({
							top: _section2.offsetTop - 150,
							behavior: 'smooth',
						});
					}
				}
			});
		});
		const hamburger = document.querySelector('.hamburger');
		if (hamburger) {
			hamburger.addEventListener('click', function () {
				document.body.classList.toggle('nav-open');
			});
		}
		const navitems = document.querySelectorAll('.hamburger-nav a');
		navitems.forEach((item) => {
			item.addEventListener('click', function () {
				document.body.classList.remove('nav-open');
			});
		});
		const promobanner = document.querySelector('.promo-banner');
		if (promobanner) {
			const button = promobanner.querySelector('svg');
			button.addEventListener('click', function () {
				promobanner.style.display = 'none';
			});
		}
		const menuItem = document.querySelectorAll('.current-menu a');
		for (var i = 0; i < menuItem.length; i++) {
			menuItem[i].addEventListener('click', function () {
				// remove active class for all elements
				for (var i = 0; i < menuItem.length; i++) {
					menuItem[i].classList.remove('current_page_item');
					menuItem[i].classList.remove("active");
				}
				// add active to clicked element
				this.classList.add('current_page_item');
			});
		}
	},
};

export default Header;
